export const BACK = "back";
export const CLOSE = "close";
export const NEXT = "next";
export const SAVE = "save";
